import React from 'react';

import { TenantSelector } from '../../components/TenantSelector/TenantSelector';

export const SelectTenant: React.FC = () => {
  return <TenantSelector />;
};
